
// This should go to a .config() block but I do need access to $filter service
// (I could hack around via angular.element(document).injector() but somehow it doesn't seem cleaner)

materialDateFormatRun.$inject = ['$mdDateLocale', '$filter'];
export function materialDateFormatRun($mdDateLocale, $filter) {

  // Let's have material components format the dates just like the rest of our angular app
  // (instead of going for whatever format they guess from the browser's preferred language)
  
  $mdDateLocale.formatDate = function(date) {
    return date ? $filter('date')(date) : '';
  };

  $mdDateLocale.parseDate = function(dateString) {
    return new Date(dateString);
  };

}